export const config = {
    contact: {
        companyName: "Cityside Fiber",
        address1: "100 Spectrum Center Dr",
        address2: "",
        city: "Irvine",
        state: "CA",
        zip: "92618",
        phone: "949-779-2489",
        email: "devs@citysidefiber.com",
        logo: "",
    },
    app: {
        title: "Project Layers",
    },
    version: "0.7.2"
}